/*
 * Copyright © 2017-Present, The Freshwater Trust, all rights reserved.
 */

import {BaseValidator} from "./BaseValidator";
import {ObjectUtils} from "../../../Utils";
import {service as ContactService} from "../../../Services/ContactService";
import React, {Fragment} from "react";
import {StreamBankLink} from "../../../Components/Common/StreamBankLink";

export class DuplicateContactValidator extends BaseValidator {
	constructor() {
		super();
		this.duplicated = null;
		this.lastSearch = {};
	}

	name(model) {
		return this.message(model);
	}

	async logic(model, data) {
		const {
			stakeholderTypeId,
			firstName,
			middleName,
			lastName,
			organizationName,
			stakeholderId,
			organizationId
		} = data;

		let searchTerms = {};

		if (Number(stakeholderTypeId) === 1) {
			if (!firstName || !lastName) {
				return true;
			}
			searchTerms = {firstName, middleName, lastName, organizationId};
		}

		if (Number(stakeholderTypeId) === 2) {
			if (!organizationName) {
				return true;
			}
			searchTerms = {organizationName, organizationId};
		}

		const currentSearch = {...searchTerms, stakeholderTypeId, stakeholderId}

		// only check for duplicate contacts if relevant values change
		if (!ObjectUtils.Compare(currentSearch, this.lastSearch)) {

			const {result, error} = await ContactService.FindByName(searchTerms);
			if (error) {
				console.error(error);
				return true;
			}

			// find contact with same name with different stakeholderID and same organization
			this.duplicated = stakeholderId ? result.find((x) => (
				x.stakeholderId !== stakeholderId && x.organizationId === organizationId
			)) : result[0];

			this.lastSearch = currentSearch;
		}

		return this.duplicated === undefined;
	}

	message(model, data) {
		const displayName = ContactService.GetTitle(this.duplicated);
		const toolParam = Object.fromEntries(new URLSearchParams(window.location.search));
		return <Fragment>
			A contact named <b>{displayName}</b> already exists.
			Click <StreamBankLink
				Tool={'contacts/' + this.duplicated.stakeholderId}
				ToolParam={Object.keys(toolParam).length ? toolParam : null}
				target="_blank"
			>here</StreamBankLink> to
			view the existing contact instead.
		</Fragment>;
	}
}